/**
 * Design board attachment preview kind (MIME-first, filename fallback).
 */

function safeStr(value) {
  return String(value ?? "").trim();
}

function fileLabel(file = {}) {
  return safeStr(file?.name || file?.displayName || file?.title);
}

export function isDesignBoardMediaImage(file = {}) {
  const mime = safeStr(file?.contentType || file?.type).toLowerCase();
  if (mime.startsWith("image/")) return true;
  return /\.(png|jpe?g|webp|gif|heic|heif)$/i.test(fileLabel(file));
}

export function isDesignBoardMediaPdf(file = {}) {
  const mime = safeStr(file?.contentType || file?.type).toLowerCase();
  if (mime === "application/pdf") return true;
  return /\.pdf$/i.test(fileLabel(file));
}

/** Image wins when both MIME and extension could disagree but MIME is image/*. */
export function designBoardMediaPreviewKind(file = {}) {
  if (isDesignBoardMediaImage(file)) return "image";
  if (isDesignBoardMediaPdf(file)) return "pdf";
  return "unsupported";
}

export function designBoardMediaTypeLabel(file = {}) {
  const kind = designBoardMediaPreviewKind(file);
  if (kind === "pdf") return "PDF";
  if (kind === "image") return "Image";
  const mime = safeStr(file?.contentType || file?.type);
  return mime || "File";
}

const HTTP_URL_RE = /^https?:\/\/.+/i;

export function validateDesignBoardInspirationUrl(rawUrl = "") {
  const url = safeStr(rawUrl);
  if (!url) return { ok: true, url: "" };
  if (!HTTP_URL_RE.test(url)) {
    return { ok: false, error: "Source URL must start with http:// or https://." };
  }
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return { ok: false, error: "Source URL must use http or https." };
    }
    return { ok: true, url: parsed.toString() };
  } catch {
    return { ok: false, error: "Enter a valid source URL (http:// or https://)." };
  }
}
